import { useLocation } from 'react-router-dom';
import { Logo } from '../../common/Logo';
import styles from './Navbar.module.css';

export const Navbar = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <nav className={styles.nav}>
      <Logo />
      {isHomePage && (
        <div className={styles.navLinks}>
          <a href="#features">Features</a>
          <a href="#how-it-works">How it Works</a>
          <a href="https://apps.apple.com/us/app/solosense/id6742793439" className={styles.navCta}>Download</a>
        </div>
      )}
    </nav>
  );
};
